export default ["locality"]